<template>
  <v-app
    id="materialpro"
    :class="`${
      !$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'
    }`"
  >
    <router-view />
  </v-app>
</template>

<script>
export default {
  created() {
    if (localStorage.getItem("accessToken") === null) {
      this.$router.replace("authentication/fulllogin");
    }
  },
  name: "App",

  components: {},
};
</script>
